<template>
  <div class="l_stamp_faq">
    <div class="container">
      <div class="content">
        <h3>① QRコードでスタンプをゲット</h3>
        <hr />
        <p>
          スタンプが受け取れない場合はQRコードをご準備致しますので、スタッフにお声がけください。QRカメラを起動してQRコードを読み込み、スタンプをゲットしてください。
        </p>
        <br />
        <br />
        <div class="l_button__external">
          <UIButton :label="'QRカメラでゲット'" @click="tapCamera" />
        </div>
        <br />
        <br />       
        <h3>
          ② 端末がAndroidの場合、 <br />GooglePlay開発者サービスを確認
        </h3>
        <hr />
        <p>
          お使いの端末がAndroidの場合、位置情報やカメラ機能を利用の際に端末にあらかじめインストールされている『GooglePlay開発者サービス』と連携します。<br />
          『GooglePlay開発者サービス』で不具合が起きている場合、スタンプを獲得できないことがありますので下記をお試しください。
        </p>
        <br />
        <div style="border: 2px solid #d0d0d0; border-radius: 8px; padding: 1.25rem">
          <p style="color: #602209; font-weight: bold; border-bottom: 1px solid; padding-bottom: 0.5rem; margin-bottom: 1rem; text-align: center">
            『GooglePlay開発者サービス』の<br />アップデート
          </p>
          <p style="font-size: 14px">
            ①Android端末から<a style="text-decoration: underline" @click="googlePlayDeveloperServiceLink">こちら</a>のリンクをタップ。<br />
            ②アップデートボタンからアップデートしてください。
            <br /><br />
            <span style="color: #666; font-size: 12px">
              ※「無効化」と表示されている場合、最新版がインストールされているため、アップデートは不要です。
            </span>
          </p>
        </div>
        <br />
        <div style="border: 2px solid #d0d0d0; border-radius: 8px; padding: 1.25rem">
          <p style="color: #602209; font-weight: bold; border-bottom: 1px solid; padding-bottom: 0.5rem; margin-bottom: 1rem; text-align: center">
            『GooglePlay開発者サービス』の<br />キャッシュ削除
          </p>
          <p style="font-size: 14px">
            アップデートでも改善されない場合、下記をお試しください。<br /><br />
            ①設定＞アプリ＞全てのアプリ＞GoolePlay開発者サービスをタップ。<br />
            ②Android5.0以前の場合、画面下部にある「キャッシュを消去」をタップ。Android6.0以降の場合、アプリ情報の中にある「ストレージ」より「キャッシュを消去」をタップしてください。
          </p>
        </div>
        <br />
        <div style="border: 2px solid #d0d0d0; border-radius: 8px; padding: 1.25rem">
          <p style="color: #602209; font-weight: bold; border-bottom: 1px solid; padding-bottom: 0.5rem; margin-bottom: 1rem; text-align: center">
            『GooglePlay開発者サービス』の<br />データを削除
          </p>
          <p style="font-size: 14px">
            キャッシュ削除でも改善されない場合、下記をお試しください。<br /><br />
            ①設定＞アプリ＞すべてのアプリ＞GooglePlay開発者サービスをタップ。<br />
            ②Android5.0以前の場合、「容量管理」をタップし、「データを全て消去」をタップしてください。Android6.0以降の場合、アプリ情報の中にある「ストレージ」より「データを全て消去」をタップしてください。
            <br /><br />
            <span style="color: #666; font-size: 12px">
              ※こちらを実施した場合、Googleが提供しているアプリやサービスの再ログインが必要になります。
            </span>
          </p>
        </div>
        <br />
        <span style="color: #666; font-size: 12px">
          ※Android5.0未満の場合、Googleでのサポート終了のためGooglePlay開発者サービスを新たにインストールできません。あらかじめご了承ください。
        </span>
        <br />
        <br />
        <br />
        <h3>③ アプリ設定を確認</h3>
        <hr />
        <p>
          アプリ設定画面から位置情報、Bluetooth、プッシュ通知を「有効」に変更してください。
        </p>
        <br />
        <p class="text-center">
          （プッシュ通知をONにすると、スタンプをゲットできるお得なお知らせが届きます。）
        </p>
        <div style="text-align: center">
          <img
            :src="require('@/assets/img/faq/setting20221114.png')"
            style="width: 75%"
            alt=""
          />
        </div>
        <div class="caption">
          ※iOS13以下、Androidは「位置情報」「Bluetooth」
          「通知」のみ表示されます。
        </div>
        <div class="l_button__external">
          <UIButton
            :label="'いますぐアプリ設定する'"
            @click="() => tapLink(1)"
          />
        </div>
        <br />
        <br />
        <h3>＜位置情報をONにする＞</h3>
        <br />
        <div class="box">
          <h4>iOSの場合</h4>
          <p>
            お使いの端末の「設定 ＞ フレンドリーアプリ ＞
            位置情報」より「常に許可」に変更してください。
          </p>
          <div class="caption" style="margin-top: 0.5em">
            ※iOS13以下の場合は「常に許可」のみ設定となります。
          </div>
          <br />

          <p>
            アプリ設定画面からも位置情報サービス画面に遷移することができます。
          </p>
          <img :src="require('@/assets/img/faq/location@3x.png')" />
          <div class="caption">
            ※iOS14以上の方は「正確な位置情報」も合わせてONにしてください。
          </div>
          <br />
        </div>
        <br />
        <div class="box">
          <h4>Androidの場合</h4>
          <p>
            お使いの端末の「設定 ＞
            位置情報」より設定をONにする、または「常に許可」に変更してください。アプリ設定画面からも位置情報サービス画面に遷移することができます。
          </p>
          <br />
          <table>
            <tr>
              <td valign="top" style="padding-top: 3px" width="25">※</td>
              <td>
                <p>
                  お使いのスマートフォンがAndroid OS
                  6.0以上の場合は、アプリの権限設定で、位置情報がONになっているかご確認ください。
                </p>
                <p class="text-center">
                  （設定＞アプリ＞香の川製麺＞許可＞位置情報をON
                </p>
              </td>
            </tr>
            <tr style="height: 1em">
              <td />
              <td />
            </tr>
            <tr>
              <td valign="top" style="padding-top: 3px" width="25">※</td>
              <td>
                <p>
                  お使いのスマートフォンがAndroidの場合は設定画面で位置情報を「常に許可」の上、「位置情報精度オン」または「高精度」を選択してください。
                </p>
              </td>
            </tr>
          </table>
          <div style="text-align: center">
            <img
              :src="require('@/assets/img/faq/location-setting-android.png')"
              style="width: 85%"
            />
          </div>
          <br />
        </div>
        <div class="l_button__external">
          <UIButton
            :label="'いますぐアプリ設定する'"
            @click="() => tapLink(2)"
          />
        </div>
        <br />
        <br />
        <h3>＜BluetoothをONにする＞</h3>
        <br />
        <div class="box">
          <table>
            <tr>
              <td valign="top">
                <h4>iOSの場合</h4>
                <p>
                  お使いの端末の画面の下を上方向にスライドすると出てくる設定パネルでON/OFFができます。
                </p>
              </td>
              <td valign="top" width="40%">
                <img
                  style="margin-top: 0px; margin-left: 5px"
                  :src="require('@/assets/img/faq/bluetooth@3x.jpg')"
                />
              </td>
            </tr>
          </table>
        </div>
        <br />
        <div class="box">
          <h4>Androidの場合</h4>
          <p>
            お使いの端末の「設定 ＞
            Bluetooth」より設定をONにしてください。アプリ設定画面からもBluetooth設定画面に遷移することができます。
          </p>
          <br />
        </div>
        <br />
        <h3>＜通知をONにする＞</h3>
        <br />
        <div class="box">
          <h4>iOSの場合</h4>
          <p>
            お使いの端末の「設定 ＞
            フレンドリーアプリ＞通知」より「通知を許可」をONにしてください。アプリ設定画面からも通知画面に遷移することができます。
          </p>
          <img :src="require('@/assets/img/faq/notification@3x.png')" />
          <p class="caption">
            ※iOS13以下の場合は「位置情報」「Bluetooth」「通知」のみ表示されます。
          </p>
          <br />
        </div>
        <br />
        <div class="box">
          <h4>Androidの場合</h4>
          <p>
            お使いの端末の「設定＞アプリケーション(アプリ＞アプリケーション管理(アプリを管理)＞香の川製麺」より、「通知を表示」にチェックを入れてください。アプリ設定画面からも香の川製麺のアプリ設定画面に遷移することができます。
          </p>
          <br />
        </div>
        <div class="l_button__external">
          <UIButton
            :label="'いますぐアプリ設定する'"
            @click="() => tapLink(3)"
          />
        </div>
        <br />
        <br />
        <h3>
          ④ 更新マークを押す<br />
          <span class="small">（アプリバージョン2.4.0以降対応）</span>
        </h3>
        <hr />
        <p>
          通信状態などによっては画面が更新されにくい場合がございます。スタンプ画面右上の更新ボタンを押してスタンプカードを再読み込みしてください。
        </p>
        <div class="l_image_center">
          <img :src="require('@/assets/img/faq/reload_stamps.png')" />
        </div>
        <br />
        <br />
        <h3>⑤ 獲得位置を確認</h3>
        <hr />
        <p>
          スタンプは、レジの近くでゲットできます。
          お店の奥や、エントランス付近など、レジから離れた場所の場合、ゲットできない可能性があります。
        </p>
        <br />
        <br />
        <h3>⑥ 機内モードを確認</h3>
        <hr />
        <p>
          設定等に問題がない場合、機内モードをON⇨OFFにすると、ご利用いただける場合があります。
        </p>
        <br />
        <div class="box">
          <table>
            <tr>
              <td valign="top">
                <h4>iOSの場合</h4>
                <p>
                  画面の下を上方向にスライドすると出てくる設定パネルでON/OFFができます。
                </p>
              </td>
              <td valign="top" width="40%">
                <img
                  style="margin-top: 0px; margin-left: 5px"
                  :src="require('@/assets/img/faq/airplanemode_ios@3x.jpg')"
                />
              </td>
            </tr>
          </table>
        </div>
        <br />
        <div class="box">
          <table>
            <tr>
              <td valign="top">
                <h4>Androidの場合</h4>
                <p>
                  画面上から下方向にスライドすると出てくる設定パネルでON/OFFができます。
                </p>
              </td>
              <td valign="top" width="40%">
                <img
                  style="margin-top: 0px; margin-left: 5px"
                  :src="require('@/assets/img/faq/airplanemode_android@3x.jpg')"
                />
              </td>
            </tr>
          </table>
        </div>
        <br />
        <table>
          <tr>
            <td valign="top" style="padding-top: 3px" width="25">※</td>
            <td>
              <p>
                機種によりレイアウト、設定パネルの表示方法が違う場合がございます。あらかじめご了承ください。
              </p>
            </td>
          </tr>
        </table>

        <br />
        <br />
        <h3>⑦ 省電力、省通信機能を確認</h3>
        <hr />
        <p>
          Android OS
          7.0以降で提供される「データセーバー」機能をはじめとする、各機種の省電力・省通信機能やアプリを利用された場合、スタンプが受け取れない場合があります。
        </p>
        <br />
        <p>
          スタンプ機能をご利用の際は、これらの設定をOFFにしてご利用ください。
        </p>
        <br />
        <br />
        <h3>⑧ 再起動する</h3>
        <hr />
        <p>
          設定等に問題がない場合、再起動するとご利用いただける場合があります。
        </p>
        <br />
        <br />
        <h3>⑨ お問い合わせ</h3>
        <hr />
        <p>
          スタンプが受け取れない方は、お手数ですが下記のお問い合わせよりご連絡お願いいたします。
        </p>
        <br />
        <router-link
          to="/faq/inquiry"
          @click.native="
            () => {
              trapTrackEvent(1)
            }
          "
        >
          <div class="l_button__external">
            <UIButton :label="'お問い合わせ'" />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { FactoryTrack } from '../constant/firebase.js'
import UIButton from '@/components/UIButton'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'

export default {
  name: 'FAQStamp',
  data: function () {
    return {
      userId: ''
    }
  },
  components: {
    UIButton
  },
  created() {
    document.title = 'スタンプがもらえない'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = (payload) => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Native', ['actionNavigateTo', 'actionRequestExternalLink']),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestToken']),

    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQInquiry())
          break
      }
    },
    goBack: function () {
      this.$router.push({
        name: 'FAQ'
      })
    },
    tapLink(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createSettingApp1())
          break
        case 2:
          this.trackEvent(FactoryTrack.createSettingApp2())
          break
        case 3:
          this.trackEvent(FactoryTrack.createSettingApp3())
          break
      }
      this.actionNavigateTo('1')
    },
    tapCamera() {
      this.trackEvent(FactoryTrack.createQRCamera())
      this.actionNavigateTo('3')
    },
    tapStampSupport() {
      this.trackEvent(FactoryTrack.createStampSupport())
      this.actionNavigateTo('4')
    },
    googlePlayDeveloperServiceLink() {
      this.actionRequestExternalLink('https://play.google.com/store/apps/details?id=com.google.android.gms&hl=ja&gl=US')
    }
  }
}
</script>

<style lang="scss" scoped>
.l_stamp_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;

  .l_image_center {
    text-align: center;

    img {
      width: 70%;
    }
  }
}

.l_stamp_faq h3,
.l_stamp_faq h4 {
  color: var(--accent-color);

  span.small {
    font-size: 0.7em;
  }
}

.l_stamp_faq h4 {
  margin-bottom: 15px;
}

.l_stamp_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_stamp_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_stamp_faq .content .box {
  border-radius: 6px;
  border: solid 1px #dddddd;
  padding: 10px 20px 0px;
}

.caption {
  text-align: left;
  width: 100%;

  &.right {
    text-align: right;
  }

  font-size: 3vw;
  color: rgb(102, 102, 102);
}

.l_stamp_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}

.l_stamp_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

/* メールアイコン */
.c_mail {
  padding-left: 25px;
  position: relative;
}

.c_mail::before {
  content: '';
  width: 20px;
  height: 20px;
  background: url('../assets/img/mail.svg') no-repeat;
  background-size: cover;
  position: absolute;
  top: -3px;
  left: 0;
}
</style>
